export default {
      id: "file-anyfile-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#file-anyfile",
      toString: function () {
        return this.url;
      }
    }